export default __webpack_public_path__ + "static/media/18.0c15b542.svg";